import React from 'react';
import { categorizeEmployee, formatPercentage, safeGet } from '../../utils/trainingUtils';

// Human Rights Training Coverage Details Component
export const HumanRightsTrainingCoverageDetails = ({ trainingData, traineeList, financialYearData, currentFinancialYearId }) => {
    // Initialize structure for current and previous FY
    const analysis = {
        currentFY: {
            employees: {
                permanent: { total: 0, covered: new Set() },
                otherThanPermanent: { total: 0, covered: new Set() }
            },
            workers: {
                permanent: { total: 0, covered: new Set() },
                otherThanPermanent: { total: 0, covered: new Set() }
            }
        },
        previousFY: {
            employees: {
                permanent: { total: 0, covered: new Set() },
                otherThanPermanent: { total: 0, covered: new Set() }
            },
            workers: {
                permanent: { total: 0, covered: new Set() },
                otherThanPermanent: { total: 0, covered: new Set() }
            }
        }
    };
    let currentFY = null;
    let previousFY = null;

    if (financialYearData && Array.isArray(financialYearData)) {
        const currentFYData = financialYearData.find(fy => fy.id === currentFinancialYearId);
        if (currentFYData) {
            currentFY = currentFYData.id;

            // Find previous FY (assuming they are in chronological order)
            const currentIndex = financialYearData.findIndex(fy => fy.id === currentFinancialYearId);
            if (currentIndex > 0) {
                previousFY = financialYearData[currentIndex - 1].id;
            }
        }
    }

    // Count total employees by category and employment type for both FYs
    let employeeCount = 0, workerCount = 0, uncategorizedCount = 0;
    const categoryBreakdown = {};

    if (traineeList && Array.isArray(traineeList)) {
        traineeList.forEach((trainee, index) => {
            if (!trainee) return;
            // Get the category - try multiple field names
            const categoryValue = trainee.categoryId || trainee.category_name || trainee.employeeType || trainee.category || trainee.type;

            // Track category breakdown for debugging
            if (categoryValue) {
                categoryBreakdown[categoryValue] = (categoryBreakdown[categoryValue] || 0) + 1;
            }

            // FIXED: Categorize based on the 6 specific types
            let targetCategory = null;
            let traineeEmploymentType = null;

            if (categoryValue) {
                const categoryStr = categoryValue.toString().toLowerCase();

                if (categoryValue === 'Permanent Employee') {
                    targetCategory = 'employees';
                    traineeEmploymentType = 'permanent';
                    employeeCount++;
                } else if (categoryValue === "Other than Permanent Employee") {
                    targetCategory = 'employees';
                    traineeEmploymentType = 'otherThanPermanent';
                    employeeCount++;
                } else if (categoryStr === 'kmp' || categoryStr.includes('kmp')) {
                    targetCategory = 'employees';
                    traineeEmploymentType = 'permanent';
                    employeeCount++;
                } else if (categoryStr === 'bod' || categoryStr.includes('bod') || categoryStr.includes('board of directors')) {
                    targetCategory = 'employees';
                    traineeEmploymentType = 'permanent';
                    employeeCount++;
                } else if (categoryValue === 'Permanent Worker') {
                    targetCategory = 'workers';
                    traineeEmploymentType = 'permanent';
                    workerCount++;
                } else if (categoryValue === 'Other than Permanent Worker') {
                    targetCategory = 'workers';
                    traineeEmploymentType = 'otherThanPermanent';
                    workerCount++;
                } else {
                    uncategorizedCount++;

                }
            } else {
                uncategorizedCount++;

            }

            if (targetCategory && traineeEmploymentType) {
                // Count for both current and previous FY (assuming all trainees exist in both periods)
                analysis.currentFY[targetCategory][traineeEmploymentType].total++;
                analysis.previousFY[targetCategory][traineeEmploymentType].total++;
            }
        });
    }

    // Process training data to count Human Rights training participants (category id = 3)
    let humanRightsTrainingCount = 0;
    let totalAttendantsFound = 0;

    if (trainingData && Array.isArray(trainingData)) {

        // First, let's see what training categories we have
        const trainingCategories = {};
        trainingData.forEach(training => {
            if (training?.Category?.id) {
                const id = training.Category.id;
                const title = training.Category.title || 'Unknown';
                trainingCategories[id] = title;
            }
        });

        trainingData.forEach((training, index) => {
            if (!training) return;


            // FIXED: Check if this is Human Rights training (category id = 3)
            const trainingCategoryId = training.Category?.id;

            // Handle both string and number category IDs
            if (trainingCategoryId != 3 && trainingCategoryId !== "3") {
                return;
            }

            humanRightsTrainingCount++;

            const attendants = training.attendantUsers || [];
            const trainingFY = training.financialYearId;
            totalAttendantsFound += attendants.length;


            attendants.forEach((attendant, attIndex) => {
                if (!attendant) return;


                // Get the category - try multiple field names (same as trainee logic)
                const categoryValue = attendant.categoryId || attendant.category_name || attendant.employeeType || attendant.category || attendant.type;


                // FIXED: Same categorization logic as trainees
                let targetCategory = null;
                let traineeEmploymentType = null;

                if (categoryValue) {
                    const categoryStr = categoryValue.toString().toLowerCase();

                    if (categoryValue === 'Permanent Employee') {
                        targetCategory = 'employees';
                        traineeEmploymentType = 'permanent';
                    } else if (categoryValue === "Other than Permanent Employee") {
                        targetCategory = 'employees';
                        traineeEmploymentType = 'otherThanPermanent';
                    } else if (categoryStr === 'kmp' || categoryStr.includes('kmp')) {
                        targetCategory = 'employees';
                        traineeEmploymentType = 'permanent';
                    } else if (categoryStr === 'bod' || categoryStr.includes('bod') || categoryStr.includes('board of directors')) {
                        targetCategory = 'employees';
                        traineeEmploymentType = 'permanent';
                    } else if (categoryValue === 'Permanent Worker') {
                        targetCategory = 'workers';
                        traineeEmploymentType = 'permanent';
                    } else if (categoryValue === 'Other than Permanent Worker') {
                        targetCategory = 'workers';
                        traineeEmploymentType = 'otherThanPermanent';
                    }
                }

                const employeeId = attendant.employeeId;

                if (!employeeId) {
                    return;
                }

                if (!targetCategory || !traineeEmploymentType) {
                    return;
                }

                // Add to appropriate FY based on training's financial year
                if (trainingFY === currentFY) {
                    analysis.currentFY[targetCategory][traineeEmploymentType].covered.add(employeeId);
                } else if (trainingFY === previousFY) {
                    analysis.previousFY[targetCategory][traineeEmploymentType].covered.add(employeeId);
                }
            });
        });
    }

    // Convert Sets to counts
    ['currentFY', 'previousFY'].forEach(fyKey => {
        ['employees', 'workers'].forEach(category => {
            ['permanent', 'otherThanPermanent'].forEach(empType => {
                if (analysis[fyKey][category] && analysis[fyKey][category][empType]) {
                    analysis[fyKey][category][empType].coveredCount = analysis[fyKey][category][empType].covered?.size || 0;
                    delete analysis[fyKey][category][empType].covered;
                }
            });
        });
    });
    const coverageAnalysis = {
        ...analysis,
        currentFYLabel: financialYearData.find(fy => fy.id === currentFY)?.financial_year_value,
        previousFYLabel: financialYearData.find(fy => fy.id === previousFY)?.financial_year_value
    };

    const formatDisplayValue = (total, covered) => {
        const percentage = total > 0 ? ((covered / total) * 100).toFixed(2) : '0';
        return {
            display: `${total} |${covered} |${percentage}%`,
            color: covered > 0 ? '#059669' : '#DC2626'
        };
    };

    return (
        <div style={{
            backgroundColor: "#fff",
            borderRadius: "8px",
            padding: "24px",
            marginBottom: "20px",
            boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
            border: "1px solid #D1D5DB"
        }}>

            <h2 style={{
                fontSize: "20px",
                fontWeight: "bold",
                color: "#1F2937",
                marginBottom: "24px",
                margin: 0,
                textAlign: "center"
            }}>
                Human Rights Training Coverage Details
            </h2>

            {/* Employees Section */}
            <div style={{ marginBottom: "32px" }}>
                <h3 style={{
                    fontSize: "16px",
                    fontWeight: "600",
                    color: "#374151",
                    marginBottom: "12px",
                    margin: "0 0 12px 0"
                }}>
                    Employees
                </h3>

                <table style={{
                    width: "100%",
                    borderCollapse: "collapse",
                    fontSize: "14px"
                }}>
                    <thead>
                        <tr>
                            <th style={{
                                border: "1px solid #D1D5DB",
                                padding: "12px",
                                textAlign: "left",
                                fontWeight: "600",
                                color: "#374151",
                                backgroundColor: "#F9FAFB"
                            }}>Category</th>
                            <th style={{
                                border: "1px solid #D1D5DB",
                                padding: "12px",
                                textAlign: "center",
                                fontWeight: "600",
                                color: "#374151",
                                backgroundColor: "#F9FAFB"
                            }}>
                                <div>FY {coverageAnalysis.currentFYLabel}</div>
                                <div style={{ fontSize: "12px", fontWeight: "normal", marginTop: "4px" }}>
                                    Total | Covered | %
                                </div>
                            </th>
                            <th style={{
                                border: "1px solid #D1D5DB",
                                padding: "12px",
                                textAlign: "center",
                                fontWeight: "600",
                                color: "#374151",
                                backgroundColor: "#F9FAFB"
                            }}>
                                <div>FY {coverageAnalysis.previousFYLabel}</div>
                                <div style={{ fontSize: "12px", fontWeight: "normal", marginTop: "4px" }}>
                                    Total | Covered | %
                                </div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td style={{
                                border: "1px solid #D1D5DB",
                                padding: "12px",
                                fontWeight: "500"
                            }}>Permanent</td>
                            <td style={{
                                border: "1px solid #D1D5DB",
                                padding: "12px",
                                textAlign: "center"
                            }}>
                                {(() => {
                                    const result = formatDisplayValue(
                                        safeGet(coverageAnalysis, 'currentFY.employees.permanent.total'),
                                        safeGet(coverageAnalysis, 'currentFY.employees.permanent.coveredCount')
                                    );
                                    return <span style={{ color: result.color, fontWeight: "500" }}>{result.display}</span>;
                                })()}
                            </td>
                            <td style={{
                                border: "1px solid #D1D5DB",
                                padding: "12px",
                                textAlign: "center"
                            }}>
                                {(() => {
                                    const result = formatDisplayValue(
                                        safeGet(coverageAnalysis, 'previousFY.employees.permanent.total'),
                                        safeGet(coverageAnalysis, 'previousFY.employees.permanent.coveredCount')
                                    );
                                    return <span style={{ color: result.color, fontWeight: "500" }}>{result.display}</span>;
                                })()}
                            </td>
                        </tr>
                        <tr>
                            <td style={{
                                border: "1px solid #D1D5DB",
                                padding: "12px",
                                fontWeight: "500"
                            }}>Other than Permanent</td>
                            <td style={{
                                border: "1px solid #D1D5DB",
                                padding: "12px",
                                textAlign: "center"
                            }}>
                                {(() => {
                                    const result = formatDisplayValue(
                                        safeGet(coverageAnalysis, 'currentFY.employees.otherThanPermanent.total'),
                                        safeGet(coverageAnalysis, 'currentFY.employees.otherThanPermanent.coveredCount')
                                    );
                                    return <span style={{ color: result.color, fontWeight: "500" }}>{result.display}</span>;
                                })()}
                            </td>
                            <td style={{
                                border: "1px solid #D1D5DB",
                                padding: "12px",
                                textAlign: "center"
                            }}>
                                {(() => {
                                    const result = formatDisplayValue(
                                        safeGet(coverageAnalysis, 'previousFY.employees.otherThanPermanent.total'),
                                        safeGet(coverageAnalysis, 'previousFY.employees.otherThanPermanent.coveredCount')
                                    );
                                    return <span style={{ color: result.color, fontWeight: "500" }}>{result.display}</span>;
                                })()}
                            </td>
                        </tr>
                        <tr style={{ backgroundColor: "#F9FAFB" }}>
                            <td style={{
                                border: "1px solid #D1D5DB",
                                padding: "12px",
                                fontWeight: "600"
                            }}>Total Employees</td>
                            <td style={{
                                border: "1px solid #D1D5DB",
                                padding: "12px",
                                textAlign: "center"
                            }}>
                                {(() => {
                                    const totalEmployees = safeGet(coverageAnalysis, 'currentFY.employees.permanent.total') +
                                        safeGet(coverageAnalysis, 'currentFY.employees.otherThanPermanent.total');
                                    const totalCovered = safeGet(coverageAnalysis, 'currentFY.employees.permanent.coveredCount') +
                                        safeGet(coverageAnalysis, 'currentFY.employees.otherThanPermanent.coveredCount');
                                    const result = formatDisplayValue(totalEmployees, totalCovered);
                                    return <span style={{ color: result.color, fontWeight: "600" }}>{result.display}</span>;
                                })()}
                            </td>
                            <td style={{
                                border: "1px solid #D1D5DB",
                                padding: "12px",
                                textAlign: "center"
                            }}>
                                {(() => {
                                    const totalEmployees = safeGet(coverageAnalysis, 'previousFY.employees.permanent.total') +
                                        safeGet(coverageAnalysis, 'previousFY.employees.otherThanPermanent.total');
                                    const totalCovered = safeGet(coverageAnalysis, 'previousFY.employees.permanent.coveredCount') +
                                        safeGet(coverageAnalysis, 'previousFY.employees.otherThanPermanent.coveredCount');
                                    const result = formatDisplayValue(totalEmployees, totalCovered);
                                    return <span style={{ color: result.color, fontWeight: "600" }}>{result.display}</span>;
                                })()}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            {/* Workers Section */}
            <div>
                <h3 style={{
                    fontSize: "16px",
                    fontWeight: "600",
                    color: "#374151",
                    marginBottom: "12px",
                    margin: "0 0 12px 0"
                }}>
                    Workers
                </h3>

                <table style={{
                    width: "100%",
                    borderCollapse: "collapse",
                    fontSize: "14px"
                }}>
                    <thead>
                        <tr>
                            <th style={{
                                border: "1px solid #D1D5DB",
                                padding: "12px",
                                textAlign: "left",
                                fontWeight: "600",
                                color: "#374151",
                                backgroundColor: "#F9FAFB"
                            }}>Category</th>
                            <th style={{
                                border: "1px solid #D1D5DB",
                                padding: "12px",
                                textAlign: "center",
                                fontWeight: "600",
                                color: "#374151",
                                backgroundColor: "#F9FAFB"
                            }}>
                                <div>FY {coverageAnalysis.currentFYLabel}</div>
                                <div style={{ fontSize: "12px", fontWeight: "normal", marginTop: "4px" }}>
                                    Total | Covered | %
                                </div>
                            </th>
                            <th style={{
                                border: "1px solid #D1D5DB",
                                padding: "12px",
                                textAlign: "center",
                                fontWeight: "600",
                                color: "#374151",
                                backgroundColor: "#F9FAFB"
                            }}>
                                <div>FY {coverageAnalysis.previousFYLabel}</div>
                                <div style={{ fontSize: "12px", fontWeight: "normal", marginTop: "4px" }}>
                                    Total | Covered | %
                                </div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td style={{
                                border: "1px solid #D1D5DB",
                                padding: "12px",
                                fontWeight: "500"
                            }}>Permanent</td>
                            <td style={{
                                border: "1px solid #D1D5DB",
                                padding: "12px",
                                textAlign: "center"
                            }}>
                                {(() => {
                                    const result = formatDisplayValue(
                                        safeGet(coverageAnalysis, 'currentFY.workers.permanent.total'),
                                        safeGet(coverageAnalysis, 'currentFY.workers.permanent.coveredCount')
                                    );
                                    return <span style={{ color: result.color, fontWeight: "500" }}>{result.display}</span>;
                                })()}
                            </td>
                            <td style={{
                                border: "1px solid #D1D5DB",
                                padding: "12px",
                                textAlign: "center"
                            }}>
                                {(() => {
                                    const result = formatDisplayValue(
                                        safeGet(coverageAnalysis, 'previousFY.workers.permanent.total'),
                                        safeGet(coverageAnalysis, 'previousFY.workers.permanent.coveredCount')
                                    );
                                    return <span style={{ color: result.color, fontWeight: "500" }}>{result.display}</span>;
                                })()}
                            </td>
                        </tr>
                        <tr>
                            <td style={{
                                border: "1px solid #D1D5DB",
                                padding: "12px",
                                fontWeight: "500"
                            }}>Other than Permanent</td>
                            <td style={{
                                border: "1px solid #D1D5DB",
                                padding: "12px",
                                textAlign: "center"
                            }}>
                                {(() => {
                                    const result = formatDisplayValue(
                                        safeGet(coverageAnalysis, 'currentFY.workers.otherThanPermanent.total'),
                                        safeGet(coverageAnalysis, 'currentFY.workers.otherThanPermanent.coveredCount')
                                    );
                                    return <span style={{ color: result.color, fontWeight: "500" }}>{result.display}</span>;
                                })()}
                            </td>
                            <td style={{
                                border: "1px solid #D1D5DB",
                                padding: "12px",
                                textAlign: "center"
                            }}>
                                {(() => {
                                    const result = formatDisplayValue(
                                        safeGet(coverageAnalysis, 'previousFY.workers.otherThanPermanent.total'),
                                        safeGet(coverageAnalysis, 'previousFY.workers.otherThanPermanent.coveredCount')
                                    );
                                    return <span style={{ color: result.color, fontWeight: "500" }}>{result.display}</span>;
                                })()}
                            </td>
                        </tr>
                        <tr style={{ backgroundColor: "#F9FAFB" }}>
                            <td style={{
                                border: "1px solid #D1D5DB",
                                padding: "12px",
                                fontWeight: "600"
                            }}>Total Workers</td>
                            <td style={{
                                border: "1px solid #D1D5DB",
                                padding: "12px",
                                textAlign: "center"
                            }}>
                                {(() => {
                                    const totalWorkers = safeGet(coverageAnalysis, 'currentFY.workers.permanent.total') +
                                        safeGet(coverageAnalysis, 'currentFY.workers.otherThanPermanent.total');
                                    const totalCovered = safeGet(coverageAnalysis, 'currentFY.workers.permanent.coveredCount') +
                                        safeGet(coverageAnalysis, 'currentFY.workers.otherThanPermanent.coveredCount');
                                    const result = formatDisplayValue(totalWorkers, totalCovered);
                                    return <span style={{ color: result.color, fontWeight: "600" }}>{result.display}</span>;
                                })()}
                            </td>
                            <td style={{
                                border: "1px solid #D1D5DB",
                                padding: "12px",
                                textAlign: "center"
                            }}>
                                {(() => {
                                    const totalWorkers = safeGet(coverageAnalysis, 'previousFY.workers.permanent.total') +
                                        safeGet(coverageAnalysis, 'previousFY.workers.otherThanPermanent.total');
                                    const totalCovered = safeGet(coverageAnalysis, 'previousFY.workers.permanent.coveredCount') +
                                        safeGet(coverageAnalysis, 'previousFY.workers.otherThanPermanent.coveredCount');
                                    const result = formatDisplayValue(totalWorkers, totalCovered);
                                    return <span style={{ color: result.color, fontWeight: "600" }}>{result.display}</span>;
                                })()}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    );
};